export const useDashboardId = () => {
  const dashboardId = window.location.pathname.split('/')[1] || null;

  return { dashboardId };
};
